import styled, { css } from 'styled-components';

export const SidebarStyled = styled.div`
    /* background-color: ${({ theme }) => theme.branding.gray.darker}; */
    grid-area: sidebar;
    background-color: #242e3e;
    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;
`;

export const SidebarNav = styled.div`
    ${({ theme }) => theme.mixins.gridRowCenter};
    gap: 0;
    justify-items: flex-start;
`;

export const NavItem = styled.div<{ isActive?: boolean }>`
    /* ${({ theme }) => theme.mixins.flexCenter}; */
    /* color: ${({ theme }) => theme.branding.gray.main}; */
    color: #b5bdca;
    height: 45px;
    width: 100%;
    display: grid;
    align-items: center;
    padding: 7px 10px 7px 20px;
    ${({ theme }) => theme.mixins.afterPseudoOption};
    cursor: pointer;
    transition: all 300ms;
    ${({ theme }) => theme.typography.sideBar_navItem};
    font-weight: 400;
    gap: 0.5rem;
    grid-auto-flow: column;
    grid-auto-columns: max-content;

    ${({ isActive, theme }) =>
        isActive
            ? css`
                  /* color: ${({ theme }) => theme.branding.primary.main}; */
                  color: #fff;
                  background-color: #1d2431;
                  &::after {
                      width: 10px;
                      background-color: #1ea7fd;
                  }
              `
            : css`
                  &:hover {
                      background-color: #104b6e;
                      color: #d9d9d9;
                  }
              `};
`;

export const NavSectionWrapper = styled.div`
    width: 100%;
`;

export const NavSectionTitle = styled.div`
    width: 100%;
    color: #8090a5;
    font-weight: 300;
    ${({ theme }) => theme.typography.sideBar_subHeader};
    padding: 25px 15px 15px 20px;
`;
